import PropTypes from 'prop-types';
import styles from './HeaderTextAnimation.module.css';

function HeaderTextAnimation({ children = null, fullWidth = false }) {
  return (
    <div
      className={`aaco-clip-animation h-[68px] md:h-[139px] ${
        fullWidth ? 'w-full' : 'w-fit'
      }  ${styles.reveal} `}
    >
      {children}
    </div>
  );
}

HeaderTextAnimation.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};


export default HeaderTextAnimation;
